import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { RouteHelpers } from '@/mixins';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ScriveTemplateManagement = () =>
  import(
    /* webpackChunkName: "ScriveTemplates" */
    '@/views/configuration/scrive/ScriveTemplateManagement.vue'
  );

const ScriveEditTemplate = () =>
  import(
    /* webpackChunkName: "ScriveTemplates" */
    '@/views/configuration/scrive/ScriveEditTemplate.vue'
  );

const ScriveAddTemplate = () =>
  import(
    /* webpackChunkName: "ScriveTemplates" */
    '@/views/configuration/scrive/ScriveAddTemplate.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'scrivetemplates',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Scrive Templates'
};

const treeView = {
  treeView: ConfigurationTreeView
};

export const TemplateRoutes = [
  {
    ...Configuration.Scrive.Template.Management,
    components: {
      default: ScriveTemplateManagement,
      ...treeView
    },
    meta
  },
  {
    ...Configuration.Scrive.Template.Edit,
    components: {
      default: ScriveEditTemplate,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'id']);
    }
  },
  {
    ...Configuration.Scrive.Template.Add,
    components: {
      default: ScriveAddTemplate,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId']);
    }
  }
];
